export class Cursor {
    constructor(id, name, image, cursorPath, pointerPath, collectionName, collectionId, width, height) {
        this.id = id;
        this.name = name;
        this.image = image;
        this.cursorPath = cursorPath;
        this.pointerPath = pointerPath;
        this.collectionName = collectionName;
        this.collectionId = collectionId;
        this.width = width;
        this.height = height;
    }
}